import { SingleSeatMerchandisingVariantEnum } from 'src/domain';

// GA4 banner_name per the Single Seat Subscription tracking spec. Shared by the
// SRP inline banner and the in-grid tile so both report the same name.
export const singleSeatBannerNames: Readonly<
  Record<SingleSeatMerchandisingVariantEnum, string>
> = {
  [SingleSeatMerchandisingVariantEnum.CREATIVE]:
    'single_seat_subscription_creative',
  [SingleSeatMerchandisingVariantEnum.EDITORIAL]:
    'single_seat_subscription_editorial',
  [SingleSeatMerchandisingVariantEnum.CREATIVE_AND_EDITORIAL]:
    'single_seat_subscription_mixed',
};

// The call-to-action translation key: one plan for a single family, plans
// (plural) when the market sells both.
export const singleSeatCtaKeys: Readonly<
  Record<SingleSeatMerchandisingVariantEnum, string>
> = {
  [SingleSeatMerchandisingVariantEnum.CREATIVE]: 'explore_plan',
  [SingleSeatMerchandisingVariantEnum.EDITORIAL]: 'explore_plan',
  [SingleSeatMerchandisingVariantEnum.CREATIVE_AND_EDITORIAL]: 'explore_plans',
};
